import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Debug logging
console.log("SubscriptionSuccess module loaded");

// Make sure this component follows the same pattern as other dashboard pages
const SubscriptionSuccess: React.FC = () => {
  console.log("SubscriptionSuccess component rendering");
  
  useEffect(() => {
    // Debug log
    console.log("SubscriptionSuccess component mounted");
    
    // Set page title
    document.title = "Subscription Successful | AccuPrice";
    
    // Show success toast
    toast.success('Your subscription was processed successfully!');
    
    // Set subscription status in localStorage
    localStorage.setItem('status', 'true');
    localStorage.setItem('status2', 'true');
    
    // Track the Subscribe event with Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'Subscribe', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'});
    }

    // Google Ads conversion tracking would go here
    // Example:
    // if (window.gtag) {
    //   window.gtag('event', 'conversion', {
    //     'send_to': 'AW-CONVERSION_ID/CONVERSION_LABEL',
    //     'value': 1.0,
    //     'currency': 'USD',
    //     'transaction_id': ''
    //   });
    // }

    // In browser console
    console.log(localStorage.getItem('userSession'));
    console.log(localStorage.getItem('email'));

    // Force visibility with JavaScript
    setTimeout(() => {
      const element = document.getElementById('subscription-success-test');
      if (element) {
        element.style.display = 'block';
        element.style.visibility = 'visible';
        element.style.opacity = '1';
        element.style.position = 'static';
      }
    }, 500);
  }, []);

  return (
    <div style={styles.container}>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover />
      <div style={styles.content}>
        <h1 style={styles.title}>Subscription Successful!</h1>
        <p style={styles.message}>
          Your payment has been processed. We thank you for subscribing to our price list.
        </p>
        <div style={styles.buttonContainer}>
          <Link to="/dashboard/catalog" style={styles.primaryButton}>
            Browse Catalogs
          </Link>
          <Link to="/dashboard/userfactor" style={styles.secondaryButton}>
            Get Started by Setting Your Price Markups
          </Link>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: '20px',
    background: '#f5f5f5',
    minHeight: 'calc(100vh - 60px)', // Adjust for header height
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    textAlign: 'center' as 'center',
    background: 'white',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    width: '100%',
  },
  title: {
    color: '#333',
    fontSize: '28px',
    marginBottom: '20px',
  },
  message: {
    color: '#666',
    fontSize: '18px',
    marginBottom: '30px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    flexWrap: 'wrap',
  },
  primaryButton: {
    display: 'inline-block',
    padding: '12px 24px',
    background: '#1976d2', // Darker blue
    color: 'white',
    textDecoration: 'none',
    borderRadius: '5px',
    transition: 'background-color 0.3s',
    flex: '1 1 45%',
    textAlign: 'center',
  },
  secondaryButton: {
    display: 'inline-block',
    padding: '12px 24px',
    background: 'orange', // Orange color
    color: 'white',
    textDecoration: 'none',
    borderRadius: '5px',
    transition: 'background-color 0.3s',
    flex: '1 1 45%',
    textAlign: 'center',
  },
};

export default SubscriptionSuccess; 